// extracted by mini-css-extract-plugin
module.exports = {"disabled":"DonateButton_disabled__XY4SH"};